import { Link } from 'gatsby'
import { Button, Menu, Navbar } from 'maeng-daisyui'
import {
  IonicSearchOutline,
  IonicRocketOutline,
  IonicCodeSlashOutline,
  IonicReaderOutline,
  IonicLogoGithub,
} from 'maeng-icons'
import { useMemo, useRef } from 'react'
import Logo from '@/assets/images/logo.svg'
import SearchModal from './search-modal'
import { CategoryConst } from '@/types/Literal'
import useCategory from '@/hooks/useCategory'
import { MenuType } from '../../../../../packages/maeng-daisyui/src/components/menu/menu'

const Header = () => {
  const searchModalRef = useRef<HTMLDialogElement>(null)
  const handleOpenSearchModal = () => {
    searchModalRef.current?.showModal()
  }

  const [category, selectCategory] = useCategory()

  const categoryOptions: MenuType<'button'>[] = useMemo(
    () =>
      CategoryConst.map((categoryName) => ({
        key: categoryName,
        label: categoryName,
        component: 'button',
        onClick: () => selectCategory(categoryName),
        active: category === categoryName,
      })),
    [category, selectCategory],
  )
  return (
    <Navbar
      className="w-full sticky top-0 bg-base-100 shadow-sm px-8 z-10"
      left={
        <Link to="/" className="text-xl">
          <Button type="ghost" className="text-xl">
            <img src={Logo} alt="logo" className="w-[8rem] aspect-auto" />
          </Button>
        </Link>
      }
      right={
        <>
          <Button className="w-[280px] justify-start" onClick={handleOpenSearchModal}>
            <IonicSearchOutline className="w-10 h-10 pr-2" />
            Quick Search...
          </Button>
          <Menu
            direction="horizontal"
            collapsed
            menus={[
              {
                key: 'About',
                component: Link,
                label: (
                  <div className="flex gap-2 align-middle">
                    <IonicRocketOutline />
                    <b>About Me</b>
                  </div>
                ),
                to: '/portfolio',
              },
              {
                key: 'Tech',
                label: (
                  <div className="flex gap-2 align-middle">
                    <IonicCodeSlashOutline />
                    Tech
                  </div>
                ),
                children: categoryOptions,
              },
              {
                key: 'TIL',
                component: Link,
                label: (
                  <div className="flex gap-2 align-middle">
                    <IonicReaderOutline />
                    <b>TIL</b>
                  </div>
                ),
                to: '/til',
              },
              {
                key: 'Github',
                component: 'a',
                label: <IonicLogoGithub />,
                href: `https://github.com/maeng2418`,
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            ]}
          />
          <SearchModal ref={searchModalRef} />
        </>
      }
    />
  )
}

export default Header
